import { styled } from '@mui/material/styles';
import { Toolbar, InputAdornment, OutlinedInput } from '@mui/material';
import Icon from 'components/icons/Icon';
import { useTranslator } from 'translation/useTranslator';

const RootStyle = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3)
}));

const SearchStyle = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter
  }),
  '&.Mui-focused': { width: 320, boxShadow: theme.customShadows.z8 },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${theme.palette.grey[500_32]} !important`
  }
}));

type OrganizationListToolbarProps = {
  filterName: string;
  onFilterName: (value: string) => void;
  placeholder?: string;
};

export default function OrganizationListToolbar({
  filterName,
  onFilterName,
  placeholder
}: OrganizationListToolbarProps) {
  const translator = useTranslator();

  return (
    <RootStyle>
      <SearchStyle
        value={filterName}
        onChange={(e) => onFilterName(e.target.value)}
        placeholder={placeholder ?? translator.search()}
        startAdornment={
          <InputAdornment position="start">
            <Icon type="search" sx={{ color: 'text.disabled' }} />
          </InputAdornment>
        }
      />
    </RootStyle>
  );
}
